import { createApiClient, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DomainRegistrarApiConfig, DynamicOfferingApiConfig, MailboxManagementApiConfig, MetaSiteInstanceApiConfig, MetaSiteSearchApiConfig, PremiumCurrencyApiConfig, PremiumFeaturesManagerApiConfig, PremiumMyDomainsApiConfig, PremiumResellerMgmtApiConfig, PremiumUserDomainApiConfig, SitesListApiConfig } from '../../apiConfigurations/ProtoServicesApiConfigs';
import { combineApiConfigs } from '@wix/premium-fed-sdk/@apis-infra';
export const MetaSiteInstanceApiClient = createApiClient(MetaSiteInstanceApiConfig);
export const MetaSiteSearchApiClient = createApiClient(MetaSiteSearchApiConfig);
export const PremiumFeaturesManagerApiClient = createApiClient(PremiumFeaturesManagerApiConfig);
export const PremiumMyDomainsApiClient = createApiClient(PremiumMyDomainsApiConfig);
export const PremiumUserDomainApiClient = createApiClient(PremiumUserDomainApiConfig);
export const MailboxManagementApiClient = createApiClient(MailboxManagementApiConfig);
export const PremiumResellerMgmtApiClient = createApiClient(PremiumResellerMgmtApiConfig);
export const DynamicOfferingApiClient = createApiClient(DynamicOfferingApiConfig);
export const PremiumCurrencyApiClient = createApiClient(PremiumCurrencyApiConfig);
export const DomainRegistrarApiClient = createApiClient(DomainRegistrarApiConfig);
const SitesListGetSiteConfig = {
  getSite: {
    name: 'getSite',
    service: {
      baseUrl: ''
    },
    queryConfigType: QueryConfigTypes.MODERATE_DATA,
    tags: ['#sites'],
    queryFn: async _ref => {
      var _sitesResponse$sites, _sitesResponse$metada, _specificSiteResponse;
      let httpClient = _ref.httpClient,
        siteId = _ref.request.siteId;
      const _SitesListApiClient$q = SitesListApiClient.queries({
          httpClient
        }),
        querySites = _SitesListApiClient$q.querySites;
      const sitesResponse = await querySites({});
      const site = (_sitesResponse$sites = sitesResponse.sites) == null ? void 0 : _sitesResponse$sites.find(site_ => site_.id === siteId);
      if (site || !((_sitesResponse$metada = sitesResponse.metadata) != null && _sitesResponse$metada.hasNext)) {
        return {
          site
        };
      }
      const specificSiteResponse = await querySites({
        query: {
          filter: {
            siteId
          }
        }
      });
      return {
        site: (_specificSiteResponse = specificSiteResponse.sites) == null ? void 0 : _specificSiteResponse[0]
      };
    }
  }
};
export const SitesListApiClient = createApiClient(combineApiConfigs(SitesListApiConfig, SitesListGetSiteConfig));
//# sourceMappingURL=ProtoServicesApiClients.js.map